/* Countries list - App */

let CountriesList = [
    {
      "name": "Afghanistan",
      "iso_2code": "AF",
      "iso_3code": "AFG",
      "dial_code": "+93",
      "nationality": "Afghan"
    },
    {
      "name": "Åland Islands",
      "iso_2code": "AX",
      "iso_3code": "ALA",
      "dial_code": "+358",
      "nationality": "Ålandish"
    },
    {
      "name": "Albania",
      "iso_2code": "AL",
      "iso_3code": "ALB",
      "dial_code": "+355",
      "nationality": "Albanian"
    },
    {
      "name": "Algeria",
      "iso_2code": "DZ",
      "iso_3code": "DZA",
      "dial_code": "+213",
      "nationality": "Algerian"
    },
    {
      "name": "American Samoa",
      "iso_2code": "AS",
      "iso_3code": "ASM",
      "dial_code": "+1",
      "nationality": "American Samoan"
    },
    {
      "name": "Andorra",
      "iso_2code": "AD",
      "iso_3code": "AND",
      "dial_code": "+376",
      "nationality": "Andorran"
    },
    {
      "name": "Angola",
      "iso_2code": "AO",
      "iso_3code": "AGO",
      "dial_code": "+244",
      "nationality": "Angolan"
    },
    {
      "name": "Anguilla",
      "iso_2code": "AI",
      "iso_3code": "AIA",
      "dial_code": "+1",
      "nationality": "Anguillian"
    },
    {
      "name": "Antarctica",
      "iso_2code": "AQ",
      "iso_3code": "ATA",
      "dial_code": "+672",
      "nationality": "Antarctican"
    },
    {
      "name": "Antigua and Barbuda",
      "iso_2code": "AG",
      "iso_3code": "ATG",
      "dial_code": "+1",
      "nationality": "Antiguan, Barbudan"
    },
    {
      "name": "Argentina",
      "iso_2code": "AR",
      "iso_3code": "ARG",
      "dial_code": "+54",
      "nationality": "Argentinean"
    },
    {
      "name": "Armenia",
      "iso_2code": "AM",
      "iso_3code": "ARM",
      "dial_code": "+374",
      "nationality": "Armenian"
    },
    {
      "name": "Aruba",
      "iso_2code": "AW",
      "iso_3code": "ABW",
      "dial_code": "+297",
      "nationality": "Aruban"
    },
    {
      "name": "Australia",
      "iso_2code": "AU",
      "iso_3code": "AUS",
      "dial_code": "+61",
      "nationality": "Australian"
    },
    {
      "name": "Austria",
      "iso_2code": "AT",
      "iso_3code": "AUT",
      "dial_code": "+43",
      "nationality": "Austrian"
    },
    {
      "name": "Azerbaijan",
      "iso_2code": "AZ",
      "iso_3code": "AZE",
      "dial_code": "+994",
      "nationality": "Azerbaijani"
    },
    {
      "name": "The Bahamas",
      "iso_2code": "BS",
      "iso_3code": "BHS",
      "dial_code": "+1",
      "nationality": "Bahamian"
    },
    {
      "name": "Bahrain",
      "iso_2code": "BH",
      "iso_3code": "BHR",
      "dial_code": "+973",
      "nationality": "Bahraini"
    },
    {
      "name": "Bangladesh",
      "iso_2code": "BD",
      "iso_3code": "BGD",
      "dial_code": "+880",
      "nationality": "Bangladeshi"
    },
    {
      "name": "Barbados",
      "iso_2code": "BB",
      "iso_3code": "BRB",
      "dial_code": "+1",
      "nationality": "Barbadian"
    },
    {
      "name": "Belarus",
      "iso_2code": "BY",
      "iso_3code": "BLR",
      "dial_code": "+375",
      "nationality": "Belarusian"
    },
    {
      "name": "Belgium",
      "iso_2code": "BE",
      "iso_3code": "BEL",
      "dial_code": "+32",
      "nationality": "Belgian"
    },
    {
      "name": "Belize",
      "iso_2code": "BZ",
      "iso_3code": "BLZ",
      "dial_code": "+501",
      "nationality": "Belizean"
    },
    {
      "name": "Benin",
      "iso_2code": "BJ",
      "iso_3code": "BEN",
      "dial_code": "+229",
      "nationality": "Beninese"
    },
    {
      "name": "Bermuda",
      "iso_2code": "BM",
      "iso_3code": "BMU",
      "dial_code": "+1",
      "nationality": "Bermudian"
    },
    {
      "name": "Bhutan",
      "iso_2code": "BT",
      "iso_3code": "BTN",
      "dial_code": "+975",
      "nationality": "Bhutanese"
    },
    {
      "name": "Bolivia",
      "iso_2code": "BO",
      "iso_3code": "BOL",
      "dial_code": "+591",
      "nationality": "Bolivian"
    },
    {
      "name": "Bosnia and Herzegovina",
      "iso_2code": "BA",
      "iso_3code": "BIH",
      "dial_code": "+387",
      "nationality": "Bosnian, Herzegovinian"
    },
    {
      "name": "Botswana",
      "iso_2code": "BW",
      "iso_3code": "BWA",
      "dial_code": "+267",
      "nationality": "Motswana"
    },
    {
      "name": "Brazil",
      "iso_2code": "BR",
      "iso_3code": "BRA",
      "dial_code": "+55",
      "nationality": "Brazilian"
    },
    {
      "name": "British Indian Ocean Territory",
      "iso_2code": "IO",
      "iso_3code": "IOT",
      "dial_code": "+246",
      "nationality": "Indian"
    },
    {
      "name": "Virgin Islands (British)",
      "iso_2code": "VG",
      "iso_3code": "VGB",
      "dial_code": "+1",
      "nationality": "Virgin Islander"
    },
    {
      "name": "Virgin Islands (U.S.)",
      "iso_2code": "VI",
      "iso_3code": "VIR",
      "dial_code": "+1",
      "nationality": "Virgin Islander"
    },
    {
      "name": "Brunei",
      "iso_2code": "BN",
      "iso_3code": "BRN",
      "dial_code": "+673",
      "nationality": "Bruneian"
    },
    {
      "name": "Bulgaria",
      "iso_2code": "BG",
      "iso_3code": "BGR",
      "dial_code": "+359",
      "nationality": "Bulgarian"
    },
    {
      "name": "Burkina Faso",
      "iso_2code": "BF",
      "iso_3code": "BFA",
      "dial_code": "+226",
      "nationality": "Burkinabe"
    },
    {
      "name": "Burundi",
      "iso_2code": "BI",
      "iso_3code": "BDI",
      "dial_code": "+257",
      "nationality": "Burundian"
    },
    {
      "name": "Cambodia",
      "iso_2code": "KH",
      "iso_3code": "KHM",
      "dial_code": "+855",
      "nationality": "Cambodian"
    },
    {
      "name": "Cameroon",
      "iso_2code": "CM",
      "iso_3code": "CMR",
      "dial_code": "+237",
      "nationality": "Cameroonian"
    },
    {
      "name": "Canada",
      "iso_2code": "CA",
      "iso_3code": "CAN",
      "dial_code": "+1",
      "nationality": "Canadian"
    },
    {
      "name": "Cape Verde",
      "iso_2code": "CV",
      "iso_3code": "CPV",
      "dial_code": "+238",
      "nationality": "Cape Verdian"
    },
    {
      "name": "Cayman Islands",
      "iso_2code": "KY",
      "iso_3code": "CYM",
      "dial_code": "+345",
      "nationality": "Caymanian"
    },
    {
      "name": "Central African Republic",
      "iso_2code": "CF",
      "iso_3code": "CAF",
      "dial_code": "+236",
      "nationality": "Central African"
    },
    {
      "name": "Chad",
      "iso_2code": "TD",
      "iso_3code": "TCD",
      "dial_code": "+235",
      "nationality": "Chadian"
    },
    {
      "name": "Chile",
      "iso_2code": "CL",
      "iso_3code": "CHL",
      "dial_code": "+56",
      "nationality": "Chilean"
    },
    {
      "name": "China",
      "iso_2code": "CN",
      "iso_3code": "CHN",
      "dial_code": "+86",
      "nationality": "Chinese"
    },
    {
      "name": "Christmas Island",
      "iso_2code": "CX",
      "iso_3code": "CXR",
      "dial_code": "+61",
      "nationality": "Christmas Island"
    },
    {
      "name": "Cocos (Keeling) Islands",
      "iso_2code": "CC",
      "iso_3code": "CCK",
      "dial_code": "+61",
      "nationality": "Cocos Islander"
    },
    {
      "name": "Colombia",
      "iso_2code": "CO",
      "iso_3code": "COL",
      "dial_code": "+57",
      "nationality": "Colombian"
    },
    {
      "name": "Comoros",
      "iso_2code": "KM",
      "iso_3code": "COM",
      "dial_code": "+269",
      "nationality": "Comoran"
    },
    {
      "name": "Republic of the Congo",
      "iso_2code": "CG",
      "iso_3code": "COG",
      "dial_code": "+242",
      "nationality": "Congolese"
    },
    {
      "name": "Democratic Republic of the Congo",
      "iso_2code": "CD",
      "iso_3code": "COD",
      "dial_code": "+243",
      "nationality": "Congolese"
    },
    {
      "name": "Cook Islands",
      "iso_2code": "CK",
      "iso_3code": "COK",
      "dial_code": "+682",
      "nationality": "Cook Islander"
    },
    {
      "name": "Costa Rica",
      "iso_2code": "CR",
      "iso_3code": "CRI",
      "dial_code": "+506",
      "nationality": "Costa Rican"
    },
    {
      "name": "Croatia",
      "iso_2code": "HR",
      "iso_3code": "HRV",
      "dial_code": "+385",
      "nationality": "Croatian"
    },
    {
      "name": "Cuba",
      "iso_2code": "CU",
      "iso_3code": "CUB",
      "dial_code": "+53",
      "nationality": "Cuban"
    },
    {
      "name": "Cyprus",
      "iso_2code": "CY",
      "iso_3code": "CYP",
      "dial_code": "+357",
      "nationality": "Cypriot"
    },
    {
      "name": "Czech Republic",
      "iso_2code": "CZ",
      "iso_3code": "CZE",
      "dial_code": "+420",
      "nationality": "Czech"
    },
    {
      "name": "Denmark",
      "iso_2code": "DK",
      "iso_3code": "DNK",
      "dial_code": "+45",
      "nationality": "Danish"
    },
    {
      "name": "Djibouti",
      "iso_2code": "DJ",
      "iso_3code": "DJI",
      "dial_code": "+253",
      "nationality": "Djibouti"
    },
    {
      "name": "Dominica",
      "iso_2code": "DM",
      "iso_3code": "DMA",
      "dial_code": "+1",
      "nationality": "Dominican"
    },
    {
      "name": "Dominican Republic",
      "iso_2code": "DO",
      "iso_3code": "DOM",
      "dial_code": "+1",
      "nationality": "Dominican"
    },
    {
      "name": "Ecuador",
      "iso_2code": "EC",
      "iso_3code": "ECU",
      "dial_code": "+593",
      "nationality": "Ecuadorean"
    },
    {
      "name": "Egypt",
      "iso_2code": "EG",
      "iso_3code": "EGY",
      "dial_code": "+20",
      "nationality": "Egyptian"
    },
    {
      "name": "El Salvador",
      "iso_2code": "SV",
      "iso_3code": "SLV",
      "dial_code": "+503",
      "nationality": "Salvadoran"
    },
    {
      "name": "Equatorial Guinea",
      "iso_2code": "GQ",
      "iso_3code": "GNQ",
      "dial_code": "+240",
      "nationality": "Equatorial Guinean"
    },
    {
      "name": "Eritrea",
      "iso_2code": "ER",
      "iso_3code": "ERI",
      "dial_code": "+291",
      "nationality": "Eritrean"
    },
    {
      "name": "Estonia",
      "iso_2code": "EE",
      "iso_3code": "EST",
      "dial_code": "+372",
      "nationality": "Estonian"
    },
    {
      "name": "Ethiopia",
      "iso_2code": "ET",
      "iso_3code": "ETH",
      "dial_code": "+251",
      "nationality": "Ethiopian"
    },
    {
      "name": "Falkland Islands",
      "iso_2code": "FK",
      "iso_3code": "FLK",
      "dial_code": "+500",
      "nationality": "Falkland Islander"
    },
    {
      "name": "Faroe Islands",
      "iso_2code": "FO",
      "iso_3code": "FRO",
      "dial_code": "+298",
      "nationality": "Faroese"
    },
    {
      "name": "Fiji",
      "iso_2code": "FJ",
      "iso_3code": "FJI",
      "dial_code": "+679",
      "nationality": "Fijian"
    },
    {
      "name": "Finland",
      "iso_2code": "FI",
      "iso_3code": "FIN",
      "dial_code": "+358",
      "nationality": "Finnish"
    },
    {
      "name": "France",
      "iso_2code": "FR",
      "iso_3code": "FRA",
      "dial_code": "+33",
      "nationality": "French"
    },
    {
      "name": "French Guiana",
      "iso_2code": "GF",
      "iso_3code": "GUF",
      "dial_code": "+594",
      "nationality": "French"
    },
    {
      "name": "French Polynesia",
      "iso_2code": "PF",
      "iso_3code": "PYF",
      "dial_code": "+689",
      "nationality": "French Polynesian"
    },
    {
      "name": "Gabon",
      "iso_2code": "GA",
      "iso_3code": "GAB",
      "dial_code": "+241",
      "nationality": "Gabonese"
    },
    {
      "name": "The Gambia",
      "iso_2code": "GM",
      "iso_3code": "GMB",
      "dial_code": "+220",
      "nationality": "Gambian"
    },
    {
      "name": "Georgia",
      "iso_2code": "GE",
      "iso_3code": "GEO",
      "dial_code": "+995",
      "nationality": "Georgian"
    },
    {
      "name": "Germany",
      "iso_2code": "DE",
      "iso_3code": "DEU",
      "dial_code": "+49",
      "nationality": "German"
    },
    {
      "name": "Ghana",
      "iso_2code": "GH",
      "iso_3code": "GHA",
      "dial_code": "+233",
      "nationality": "Ghanaian"
    },
    {
      "name": "Gibraltar",
      "iso_2code": "GI",
      "iso_3code": "GIB",
      "dial_code": "+350",
      "nationality": "Gibraltar"
    },
    {
      "name": "Greece",
      "iso_2code": "GR",
      "iso_3code": "GRC",
      "dial_code": "+30",
      "nationality": "Greek"
    },
    {
      "name": "Greenland",
      "iso_2code": "GL",
      "iso_3code": "GRL",
      "dial_code": "+299",
      "nationality": "Greenlandic"
    },
    {
      "name": "Grenada",
      "iso_2code": "GD",
      "iso_3code": "GRD",
      "dial_code": "+1",
      "nationality": "Grenadian"
    },
    {
      "name": "Guadeloupe",
      "iso_2code": "GP",
      "iso_3code": "GLP",
      "dial_code": "+590",
      "nationality": "Guadeloupian"
    },
    {
      "name": "Guam",
      "iso_2code": "GU",
      "iso_3code": "GUM",
      "dial_code": "+1",
      "nationality": "Guamanian"
    },
    {
      "name": "Guatemala",
      "iso_2code": "GT",
      "iso_3code": "GTM",
      "dial_code": "+502",
      "nationality": "Guatemalan"
    },
    {
      "name": "Guernsey",
      "iso_2code": "GG",
      "iso_3code": "GGY",
      "dial_code": "+44",
      "nationality": "Channel Islander"
    },
    {
      "name": "Guinea",
      "iso_2code": "GN",
      "iso_3code": "GIN",
      "dial_code": "+224",
      "nationality": "Guinean"
    },
    {
      "name": "Guinea-Bissau",
      "iso_2code": "GW",
      "iso_3code": "GNB",
      "dial_code": "+245",
      "nationality": "Guinea-Bissauan"
    },
    {
      "name": "Guyana",
      "iso_2code": "GY",
      "iso_3code": "GUY",
      "dial_code": "+592",
      "nationality": "Guyanese"
    },
    {
      "name": "Haiti",
      "iso_2code": "HT",
      "iso_3code": "HTI",
      "dial_code": "+509",
      "nationality": "Haitian"
    },
    {
      "name": "Holy See (Vatican City)",
      "iso_2code": "VA",
      "iso_3code": "VAT",
      "dial_code": "+379",
      "nationality": "Vatican"
    },
    {
      "name": "Honduras",
      "iso_2code": "HN",
      "iso_3code": "HND",
      "dial_code": "+504",
      "nationality": "Honduran"
    },
    {
      "name": "Hong Kong",
      "iso_2code": "HK",
      "iso_3code": "HKG",
      "dial_code": "+852",
      "nationality": "Chinese"
    },
    {
      "name": "Hungary",
      "iso_2code": "HU",
      "iso_3code": "HUN",
      "dial_code": "+36",
      "nationality": "Hungarian"
    },
    {
      "name": "Iceland",
      "iso_2code": "IS",
      "iso_3code": "ISL",
      "dial_code": "+354",
      "nationality": "Icelander"
    },
    {
      "name": "India",
      "iso_2code": "IN",
      "iso_3code": "IND",
      "dial_code": "+91",
      "nationality": "Indian"
    },
    {
      "name": "Indonesia",
      "iso_2code": "ID",
      "iso_3code": "IDN",
      "dial_code": "+62",
      "nationality": "Indonesian"
    },
    {
      "name": "Ivory Coast",
      "iso_2code": "CI",
      "iso_3code": "CIV",
      "dial_code": "+225",
      "nationality": "Ivorian"
    },
    {
      "name": "Iran",
      "iso_2code": "IR",
      "iso_3code": "IRN",
      "dial_code": "+98",
      "nationality": "Iranian"
    },
    {
      "name": "Iraq",
      "iso_2code": "IQ",
      "iso_3code": "IRQ",
      "dial_code": "+964",
      "nationality": "Iraqi"
    },
    {
      "name": "Republic of Ireland",
      "iso_2code": "IE",
      "iso_3code": "IRL",
      "dial_code": "+353",
      "nationality": "Irish"
    },
    {
      "name": "Isle of Man",
      "iso_2code": "IM",
      "iso_3code": "IMN",
      "dial_code": "+44",
      "nationality": "Manx"
    },
    {
      "name": "Israel",
      "iso_2code": "IL",
      "iso_3code": "ISR",
      "dial_code": "+972",
      "nationality": "Israeli"
    },
    {
      "name": "Italy",
      "iso_2code": "IT",
      "iso_3code": "ITA",
      "dial_code": "+39",
      "nationality": "Italian"
    },
    {
      "name": "Jamaica",
      "iso_2code": "JM",
      "iso_3code": "JAM",
      "dial_code": "+1",
      "nationality": "Jamaican"
    },
    {
      "name": "Japan",
      "iso_2code": "JP",
      "iso_3code": "JPN",
      "dial_code": "+81",
      "nationality": "Japanese"
    },
    {
      "name": "Jersey",
      "iso_2code": "JE",
      "iso_3code": "JEY",
      "dial_code": "+44",
      "nationality": "Channel Islander"
    },
    {
      "name": "Jordan",
      "iso_2code": "JO",
      "iso_3code": "JOR",
      "dial_code": "+962",
      "nationality": "Jordanian"
    },
    {
      "name": "Kazakhstan",
      "iso_2code": "KZ",
      "iso_3code": "KAZ",
      "dial_code": "+7",
      "nationality": "Kazakhstani"
    },
    {
      "name": "Kenya",
      "iso_2code": "KE",
      "iso_3code": "KEN",
      "dial_code": "+254",
      "nationality": "Kenyan"
    },
    {
      "name": "Kiribati",
      "iso_2code": "KI",
      "iso_3code": "KIR",
      "dial_code": "+686",
      "nationality": "I-Kiribati"
    },
    {
      "name": "Kuwait",
      "iso_2code": "KW",
      "iso_3code": "KWT",
      "dial_code": "+965",
      "nationality": "Kuwaiti"
    },
    {
      "name": "Kyrgyzstan",
      "iso_2code": "KG",
      "iso_3code": "KGZ",
      "dial_code": "+996",
      "nationality": "Kirghiz"
    },
    {
      "name": "Laos",
      "iso_2code": "LA",
      "iso_3code": "LAO",
      "dial_code": "+856",
      "nationality": "Laotian"
    },
    {
      "name": "Latvia",
      "iso_2code": "LV",
      "iso_3code": "LVA",
      "dial_code": "+371",
      "nationality": "Latvian"
    },
    {
      "name": "Lebanon",
      "iso_2code": "LB",
      "iso_3code": "LBN",
      "dial_code": "+961",
      "nationality": "Lebanese"
    },
    {
      "name": "Lesotho",
      "iso_2code": "LS",
      "iso_3code": "LSO",
      "dial_code": "+266",
      "nationality": "Mosotho"
    },
    {
      "name": "Liberia",
      "iso_2code": "LR",
      "iso_3code": "LBR",
      "dial_code": "+231",
      "nationality": "Liberian"
    },
    {
      "name": "Libya",
      "iso_2code": "LY",
      "iso_3code": "LBY",
      "dial_code": "+218",
      "nationality": "Libyan"
    },
    {
      "name": "Liechtenstein",
      "iso_2code": "LI",
      "iso_3code": "LIE",
      "dial_code": "+423",
      "nationality": "Liechtensteiner"
    },
    {
      "name": "Lithuania",
      "iso_2code": "LT",
      "iso_3code": "LTU",
      "dial_code": "+370",
      "nationality": "Lithuanian"
    },
    {
      "name": "Luxembourg",
      "iso_2code": "LU",
      "iso_3code": "LUX",
      "dial_code": "+352",
      "nationality": "Luxembourger"
    },
    {
      "name": "Macau",
      "iso_2code": "MO",
      "iso_3code": "MAC",
      "dial_code": "+853",
      "nationality": "Chinese"
    },
    {
      "name": "Republic of Macedonia",
      "iso_2code": "MK",
      "iso_3code": "MKD",
      "dial_code": "+389",
      "nationality": "Macedonian"
    },
    {
      "name": "Madagascar",
      "iso_2code": "MG",
      "iso_3code": "MDG",
      "dial_code": "+261",
      "nationality": "Malagasy"
    },
    {
      "name": "Malawi",
      "iso_2code": "MW",
      "iso_3code": "MWI",
      "dial_code": "+265",
      "nationality": "Malawian"
    },
    {
      "name": "Malaysia",
      "iso_2code": "MY",
      "iso_3code": "MYS",
      "dial_code": "+60",
      "nationality": "Malaysian"
    },
    {
      "name": "Maldives",
      "iso_2code": "MV",
      "iso_3code": "MDV",
      "dial_code": "+960",
      "nationality": "Maldivan"
    },
    {
      "name": "Mali",
      "iso_2code": "ML",
      "iso_3code": "MLI",
      "dial_code": "+223",
      "nationality": "Malian"
    },
    {
      "name": "Malta",
      "iso_2code": "MT",
      "iso_3code": "MLT",
      "dial_code": "+356",
      "nationality": "Maltese"
    },
    {
      "name": "Marshall Islands",
      "iso_2code": "MH",
      "iso_3code": "MHL",
      "dial_code": "+692",
      "nationality": "Marshallese"
    },
    {
      "name": "Martinique",
      "iso_2code": "MQ",
      "iso_3code": "MTQ",
      "dial_code": "+596",
      "nationality": "French"
    },
    {
      "name": "Mauritania",
      "iso_2code": "MR",
      "iso_3code": "MRT",
      "dial_code": "+222",
      "nationality": "Mauritanian"
    },
    {
      "name": "Mauritius",
      "iso_2code": "MU",
      "iso_3code": "MUS",
      "dial_code": "+230",
      "nationality": "Mauritian"
    },
    {
      "name": "Mayotte",
      "iso_2code": "YT",
      "iso_3code": "MYT",
      "dial_code": "+262",
      "nationality": "French"
    },
    {
      "name": "Mexico",
      "iso_2code": "MX",
      "iso_3code": "MEX",
      "dial_code": "+52",
      "nationality": "Mexican"
    },
    {
      "name": "Federated States of Micronesia",
      "iso_2code": "FM",
      "iso_3code": "FSM",
      "dial_code": "+691",
      "nationality": "Micronesian"
    },
    {
      "name": "Moldova",
      "iso_2code": "MD",
      "iso_3code": "MDA",
      "dial_code": "+373",
      "nationality": "Moldovan"
    },
    {
      "name": "Monaco",
      "iso_2code": "MC",
      "iso_3code": "MCO",
      "dial_code": "+377",
      "nationality": "Monegasque"
    },
    {
      "name": "Mongolia",
      "iso_2code": "MN",
      "iso_3code": "MNG",
      "dial_code": "+976",
      "nationality": "Mongolian"
    },
    {
      "name": "Montenegro",
      "iso_2code": "ME",
      "iso_3code": "MNE",
      "dial_code": "+382",
      "nationality": "Montenegrin"
    },
    {
      "name": "Montserrat",
      "iso_2code": "MS",
      "iso_3code": "MSR",
      "dial_code": "+1",
      "nationality": "Montserratian"
    },
    {
      "name": "Morocco",
      "iso_2code": "MA",
      "iso_3code": "MAR",
      "dial_code": "+212",
      "nationality": "Moroccan"
    },
    {
      "name": "Mozambique",
      "iso_2code": "MZ",
      "iso_3code": "MOZ",
      "dial_code": "+258",
      "nationality": "Mozambican"
    },
    {
      "name": "Myanmar",
      "iso_2code": "MM",
      "iso_3code": "MMR",
      "dial_code": "+95",
      "nationality": "Burmese"
    },
    {
      "name": "Namibia",
      "iso_2code": "NA",
      "iso_3code": "NAM",
      "dial_code": "+264",
      "nationality": "Namibian"
    },
    {
      "name": "Nauru",
      "iso_2code": "NR",
      "iso_3code": "NRU",
      "dial_code": "+674",
      "nationality": "Nauruan"
    },
    {
      "name": "Nepal",
      "iso_2code": "NP",
      "iso_3code": "NPL",
      "dial_code": "+977",
      "nationality": "Nepalese"
    },
    {
      "name": "Netherlands",
      "iso_2code": "NL",
      "iso_3code": "NLD",
      "dial_code": "+31",
      "nationality": "Dutch"
    },
    {
      "name": "New Caledonia",
      "iso_2code": "NC",
      "iso_3code": "NCL",
      "dial_code": "+687",
      "nationality": "New Caledonian"
    },
    {
      "name": "New Zealand",
      "iso_2code": "NZ",
      "iso_3code": "NZL",
      "dial_code": "+64",
      "nationality": "New Zealander"
    },
    {
      "name": "Nicaragua",
      "iso_2code": "NI",
      "iso_3code": "NIC",
      "dial_code": "+505",
      "nationality": "Nicaraguan"
    },
    {
      "name": "Niger",
      "iso_2code": "NE",
      "iso_3code": "NER",
      "dial_code": "+227",
      "nationality": "Nigerien"
    },
    {
      "name": "Nigeria",
      "iso_2code": "NG",
      "iso_3code": "NGA",
      "dial_code": "+234",
      "nationality": "Nigerian"
    },
    {
      "name": "Niue",
      "iso_2code": "NU",
      "iso_3code": "NIU",
      "dial_code": "+683",
      "nationality": "Niuean"
    },
    {
      "name": "Norfolk Island",
      "iso_2code": "NF",
      "iso_3code": "NFK",
      "dial_code": "+672",
      "nationality": "Norfolk Islander"
    },
    {
      "name": "North Korea",
      "iso_2code": "KP",
      "iso_3code": "PRK",
      "dial_code": "+850",
      "nationality": "North Korean"
    },
    {
      "name": "Northern Mariana Islands",
      "iso_2code": "MP",
      "iso_3code": "MNP",
      "dial_code": "+1",
      "nationality": "American"
    },
    {
      "name": "Norway",
      "iso_2code": "NO",
      "iso_3code": "NOR",
      "dial_code": "+47",
      "nationality": "Norwegian"
    },
    {
      "name": "Oman",
      "iso_2code": "OM",
      "iso_3code": "OMN",
      "dial_code": "+968",
      "nationality": "Omani"
    },
    {
      "name": "Pakistan",
      "iso_2code": "PK",
      "iso_3code": "PAK",
      "dial_code": "+92",
      "nationality": "Pakistani"
    },
    {
      "name": "Palau",
      "iso_2code": "PW",
      "iso_3code": "PLW",
      "dial_code": "+680",
      "nationality": "Palauan"
    },
    {
      "name": "Palestine",
      "iso_2code": "PS",
      "iso_3code": "PSE",
      "dial_code": "+970",
      "nationality": "Palestinian"
    },
    {
      "name": "Panama",
      "iso_2code": "PA",
      "iso_3code": "PAN",
      "dial_code": "+507",
      "nationality": "Panamanian"
    },
    {
      "name": "Papua New Guinea",
      "iso_2code": "PG",
      "iso_3code": "PNG",
      "dial_code": "+675",
      "nationality": "Papua New Guinean"
    },
    {
      "name": "Paraguay",
      "iso_2code": "PY",
      "iso_3code": "PRY",
      "dial_code": "+595",
      "nationality": "Paraguayan"
    },
    {
      "name": "Peru",
      "iso_2code": "PE",
      "iso_3code": "PER",
      "dial_code": "+51",
      "nationality": "Peruvian"
    },
    {
      "name": "Philippines",
      "iso_2code": "PH",
      "iso_3code": "PHL",
      "dial_code": "+63",
      "nationality": "Filipino"
    },
    {
      "name": "Pitcairn Islands",
      "iso_2code": "PN",
      "iso_3code": "PCN",
      "dial_code": "+64",
      "nationality": "Pitcairn Islander"
    },
    {
      "name": "Poland",
      "iso_2code": "PL",
      "iso_3code": "POL",
      "dial_code": "+48",
      "nationality": "Polish"
    },
    {
      "name": "Portugal",
      "iso_2code": "PT",
      "iso_3code": "PRT",
      "dial_code": "+351",
      "nationality": "Portuguese"
    },
    {
      "name": "Puerto Rico",
      "iso_2code": "PR",
      "iso_3code": "PRI",
      "dial_code": "+1",
      "nationality": "Puerto Rican"
    },
    {
      "name": "Qatar",
      "iso_2code": "QA",
      "iso_3code": "QAT",
      "dial_code": "+974",
      "nationality": "Qatari"
    },
    {
      "name": "Kosovo",
      "iso_2code": "XK",
      "iso_3code": "RKS",
      "dial_code": "+383",
      "nationality": "Kosovan"
    },
    {
      "name": "Réunion",
      "iso_2code": "RE",
      "iso_3code": "REU",
      "dial_code": "+262",
      "nationality": "French"
    },
    {
      "name": "Romania",
      "iso_2code": "RO",
      "iso_3code": "ROU",
      "dial_code": "+40",
      "nationality": "Romanian"
    },
    {
      "name": "Russia",
      "iso_2code": "RU",
      "iso_3code": "RUS",
      "dial_code": "+7",
      "nationality": "Russian"
    },
    {
      "name": "Rwanda",
      "iso_2code": "RW",
      "iso_3code": "RWA",
      "dial_code": "+250",
      "nationality": "Rwandan"
    },
    {
      "name": "Saint Barthélemy",
      "iso_2code": "BL",
      "iso_3code": "BLM",
      "dial_code": "+590",
      "nationality": "Saint Barthélemy Islander"
    },
    {
      "name": "Saint Helena",
      "iso_2code": "SH",
      "iso_3code": "SHN",
      "dial_code": "+290",
      "nationality": "Saint Helenian"
    },
    {
      "name": "Saint Kitts and Nevis",
      "iso_2code": "KN",
      "iso_3code": "KNA",
      "dial_code": "+1",
      "nationality": "Kittian and Nevisian"
    },
    {
      "name": "Saint Lucia",
      "iso_2code": "LC",
      "iso_3code": "LCA",
      "dial_code": "+1",
      "nationality": "Saint Lucian"
    },
    {
      "name": "Saint Martin",
      "iso_2code": "MF",
      "iso_3code": "MAF",
      "dial_code": "+590",
      "nationality": "Saint Martin Islander"
    },
    {
      "name": "Saint Pierre and Miquelon",
      "iso_2code": "PM",
      "iso_3code": "SPM",
      "dial_code": "+508",
      "nationality": "French"
    },
    {
      "name": "Saint Vincent and the Grenadines",
      "iso_2code": "VC",
      "iso_3code": "VCT",
      "dial_code": "+1",
      "nationality": "Saint Vincentian"
    },
    {
      "name": "Samoa",
      "iso_2code": "WS",
      "iso_3code": "WSM",
      "dial_code": "+685",
      "nationality": "Samoan"
    },
    {
      "name": "San Marino",
      "iso_2code": "SM",
      "iso_3code": "SMR",
      "dial_code": "+378",
      "nationality": "Sammarinese"
    },
    {
      "name": "São Tomé and Príncipe",
      "iso_2code": "ST",
      "iso_3code": "STP",
      "dial_code": "+239",
      "nationality": "Sao Tomean"
    },
    {
      "name": "Saudi Arabia",
      "iso_2code": "SA",
      "iso_3code": "SAU",
      "dial_code": "+966",
      "nationality": "Saudi Arabian"
    },
    {
      "name": "Senegal",
      "iso_2code": "SN",
      "iso_3code": "SEN",
      "dial_code": "+221",
      "nationality": "Senegalese"
    },
    {
      "name": "Serbia",
      "iso_2code": "RS",
      "iso_3code": "SRB",
      "dial_code": "+381",
      "nationality": "Serbian"
    },
    {
      "name": "Seychelles",
      "iso_2code": "SC",
      "iso_3code": "SYC",
      "dial_code": "+248",
      "nationality": "Seychellois"
    },
    {
      "name": "Sierra Leone",
      "iso_2code": "SL",
      "iso_3code": "SLE",
      "dial_code": "+232",
      "nationality": "Sierra Leonean"
    },
    {
      "name": "Singapore",
      "iso_2code": "SG",
      "iso_3code": "SGP",
      "dial_code": "+65",
      "nationality": "Singaporean"
    },
    {
      "name": "Sint Maarten",
      "iso_2code": "SX",
      "iso_3code": "SXM",
      "dial_code": "+1",
      "nationality": "Dutch"
    },
    {
      "name": "Slovakia",
      "iso_2code": "SK",
      "iso_3code": "SVK",
      "dial_code": "+421",
      "nationality": "Slovak"
    },
    {
      "name": "Slovenia",
      "iso_2code": "SI",
      "iso_3code": "SVN",
      "dial_code": "+386",
      "nationality": "Slovene"
    },
    {
      "name": "Solomon Islands",
      "iso_2code": "SB",
      "iso_3code": "SLB",
      "dial_code": "+677",
      "nationality": "Solomon Islander"
    },
    {
      "name": "Somalia",
      "iso_2code": "SO",
      "iso_3code": "SOM",
      "dial_code": "+252",
      "nationality": "Somali"
    },
    {
      "name": "South Africa",
      "iso_2code": "ZA",
      "iso_3code": "ZAF",
      "dial_code": "+27",
      "nationality": "South African"
    },
    {
      "name": "South Georgia",
      "iso_2code": "GS",
      "iso_3code": "SGS",
      "dial_code": "+500",
      "nationality": "South Georgia and the South Sandwich Islander"
    },
    {
      "name": "South Korea",
      "iso_2code": "KR",
      "iso_3code": "KOR",
      "dial_code": "+82",
      "nationality": "South Korean"
    },
    {
      "name": "South Sudan",
      "iso_2code": "SS",
      "iso_3code": "SSD",
      "dial_code": "+211",
      "nationality": "South Sudanese"
    },
    {
      "name": "Spain",
      "iso_2code": "ES",
      "iso_3code": "ESP",
      "dial_code": "+34",
      "nationality": "Spanish"
    },
    {
      "name": "Sri Lanka",
      "iso_2code": "LK",
      "iso_3code": "LKA",
      "dial_code": "+94",
      "nationality": "Sri Lankan"
    },
    {
      "name": "Sudan",
      "iso_2code": "SD",
      "iso_3code": "SDN",
      "dial_code": "+249",
      "nationality": "Sudanese"
    },
    {
      "name": "Suriname",
      "iso_2code": "SR",
      "iso_3code": "SUR",
      "dial_code": "+597",
      "nationality": "Surinamer"
    },
    {
      "name": "Svalbard and Jan Mayen",
      "iso_2code": "SJ",
      "iso_3code": "SJM",
      "dial_code": "+4779",
      "nationality": "Norwegian"
    },
    {
      "name": "Swaziland",
      "iso_2code": "SZ",
      "iso_3code": "SWZ",
      "dial_code": "+268",
      "nationality": "Swazi"
    },
    {
      "name": "Sweden",
      "iso_2code": "SE",
      "iso_3code": "SWE",
      "dial_code": "+46",
      "nationality": "Swedish"
    },
    {
      "name": "Switzerland",
      "iso_2code": "CH",
      "iso_3code": "CHE",
      "dial_code": "+41",
      "nationality": "Swiss"
    },
    {
      "name": "Syria",
      "iso_2code": "SY",
      "iso_3code": "SYR",
      "dial_code": "+963",
      "nationality": "Syrian"
    },
    {
      "name": "Taiwan",
      "iso_2code": "TW",
      "iso_3code": "TWN",
      "dial_code": "+886",
      "nationality": "Taiwanese"
    },
    {
      "name": "Tajikistan",
      "iso_2code": "TJ",
      "iso_3code": "TJK",
      "dial_code": "+992",
      "nationality": "Tadzhik"
    },
    {
      "name": "Tanzania",
      "iso_2code": "TZ",
      "iso_3code": "TZA",
      "dial_code": "+255",
      "nationality": "Tanzanian"
    },
    {
      "name": "Thailand",
      "iso_2code": "TH",
      "iso_3code": "THA",
      "dial_code": "+66",
      "nationality": "Thai"
    },
    {
      "name": "East Timor",
      "iso_2code": "TL",
      "iso_3code": "TLS",
      "dial_code": "+670",
      "nationality": "East Timorese"
    },
    {
      "name": "Togo",
      "iso_2code": "TG",
      "iso_3code": "TGO",
      "dial_code": "+228",
      "nationality": "Togolese"
    },
    {
      "name": "Tokelau",
      "iso_2code": "TK",
      "iso_3code": "TKL",
      "dial_code": "+690",
      "nationality": "Tokelauan"
    },
    {
      "name": "Tonga",
      "iso_2code": "TO",
      "iso_3code": "TON",
      "dial_code": "+676",
      "nationality": "Tongan"
    },
    {
      "name": "Trinidad and Tobago",
      "iso_2code": "TT",
      "iso_3code": "TTO",
      "dial_code": "+1",
      "nationality": "Trinidadian"
    },
    {
      "name": "Tunisia",
      "iso_2code": "TN",
      "iso_3code": "TUN",
      "dial_code": "+216",
      "nationality": "Tunisian"
    },
    {
      "name": "Turkey",
      "iso_2code": "TR",
      "iso_3code": "TUR",
      "dial_code": "+90",
      "nationality": "Turkish"
    },
    {
      "name": "Turkmenistan",
      "iso_2code": "TM",
      "iso_3code": "TKM",
      "dial_code": "+993",
      "nationality": "Turkmen"
    },
    {
      "name": "Turks and Caicos Islands",
      "iso_2code": "TC",
      "iso_3code": "TCA",
      "dial_code": "+1",
      "nationality": "Turks and Caicos Islander"
    },
    {
      "name": "Tuvalu",
      "iso_2code": "TV",
      "iso_3code": "TUV",
      "dial_code": "+688",
      "nationality": "Tuvaluan"
    },
    {
      "name": "Uganda",
      "iso_2code": "UG",
      "iso_3code": "UGA",
      "dial_code": "+256",
      "nationality": "Ugandan"
    },
    {
      "name": "Ukraine",
      "iso_2code": "UA",
      "iso_3code": "UKR",
      "dial_code": "+380",
      "nationality": "Ukrainian"
    },
    {
      "name": "United Arab Emirates",
      "iso_2code": "AE",
      "iso_3code": "ARE",
      "dial_code": "+971",
      "nationality": "Emirati"
    },
    {
      "name": "United Kingdom",
      "iso_2code": "GB",
      "iso_3code": "GBR",
      "dial_code": "+44",
      "nationality": "British"
    },
    {
      "name": "United States",
      "iso_2code": "US",
      "iso_3code": "USA",
      "dial_code": "+1",
      "nationality": "American"
    },
    {
      "name": "Uruguay",
      "iso_2code": "UY",
      "iso_3code": "URY",
      "dial_code": "+598",
      "nationality": "Uruguayan"
    },
    {
      "name": "Uzbekistan",
      "iso_2code": "UZ",
      "iso_3code": "UZB",
      "dial_code": "+998",
      "nationality": "Uzbekistani"
    },
    {
      "name": "Vanuatu",
      "iso_2code": "VU",
      "iso_3code": "VUT",
      "dial_code": "+678",
      "nationality": "Ni-Vanuatu"
    },
    {
      "name": "Venezuela",
      "iso_2code": "VE",
      "iso_3code": "VEN",
      "dial_code": "+58",
      "nationality": "Venezuelan"
    },
    {
      "name": "Vietnam",
      "iso_2code": "VN",
      "iso_3code": "VNM",
      "dial_code": "+84",
      "nationality": "Vietnamese"
    },
    {
      "name": "Wallis and Futuna",
      "iso_2code": "WF",
      "iso_3code": "WLF",
      "dial_code": "+681",
      "nationality": "Wallis and Futuna Islander"
    },
    {
      "name": "Western Sahara",
      "iso_2code": "EH",
      "iso_3code": "ESH",
      "dial_code": "+212",
      "nationality": "Sahrawi"
    },
    {
      "name": "Yemen",
      "iso_2code": "YE",
      "iso_3code": "YEM",
      "dial_code": "+967",
      "nationality": "Yemeni"
    },
    {
      "name": "Zambia",
      "iso_2code": "ZM",
      "iso_3code": "ZMB",
      "dial_code": "+260",
      "nationality": "Zambian"
    },
    {
      "name": "Zimbabwe",
      "iso_2code": "ZW",
      "iso_3code": "ZWE",
      "dial_code": "+263",
      "nationality": "Zimbabwean"
    }
];

let Countries = {
  Countries: CountriesList,
};
  
export default Countries;
  